import { Link } from 'react-router';

import { buttonVariants, cn } from '@workspace/shadcn';
import { SuccessIcon } from '@workspace/ui';

import { AuthShell } from '../../components/auth-shell.tsx';

export default function PasswordReset() {
  return (
    <AuthShell title="Password changed">
      <div className="mt-6 flex flex-col items-center gap-4 text-center">
        <SuccessIcon />
        <p className="text-muted-foreground text-sm">
          Use your new password the next time you sign in.
        </p>
        <Link to="/signin" className={cn(buttonVariants(), 'w-full')}>
          Sign in
        </Link>
      </div>
    </AuthShell>
  );
}
